<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '520px' }"
    header="Cancelar Evento"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="fluid">
      <div class="field">
        <label for="observation">Justificativa</label>
        <Textarea
          id="observation"
          v-model="v$.observation.$model"
          placeholder="Informe a o motivo do cancelamento."
          rows="5"
          cols="30"
          :class="{
            'p-invalid': submitted && v$.observation.$invalid,
          }"
        />
        <small class="p-error" v-if="submitted && v$.observation.$invalid"
          >Justificativa é obrigatória.</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.observation.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Event from "../../../models/internal/event";

//Services
import EventService from "../../../service/internal/event/event_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["objSelected"],
  components: {},
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      observation: null,
      obj: new Event(),
      submitted: false,
      service: new EventService(),
    };
  },
  validations() {
    return {
      observation: {
        required,
      },
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.event.dialogCancel;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.event.dialogCancel = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        this.obj.observation = this.observation;
        this.service
          .changeStatus(this.obj)
          .then((data) => {
            if (data.status === 200) {
              this.$msgSuccess(data);
              this.hideDialog();
            }
          })
          .catch((error) => {
            this.$msgErro(error);
          });
      } else {
        return;
      }
    },
    hideDialog() {
      this.obj = new Event();
      this.submitted = false;
      this.observation = null;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.obj = this.objSelected;
      this.obj.status = "CANCELED";
    },
  },
};
</script>
<style scoped></style>
